import { render, staticRenderFns } from "./edit-summary.vue?vue&type=template&id=dac036c0&scoped=true&"
import script from "./edit-summary.vue?vue&type=script&lang=js&"
export * from "./edit-summary.vue?vue&type=script&lang=js&"
import style0 from "./edit-summary.vue?vue&type=style&index=0&id=dac036c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac036c0",
  null
  
)

export default component.exports